import CardManagement from "containers/PaymentMethodManagement/CardManagement";

const PaymentMethodManagement = () => {
  return (
    <div
      className={`bg-offWhite  p-4 mx-auto flex-col flex gap-8 h-screen md:w-[65vw] `}
    >
      <CardManagement />
    </div>
  );
};

export default PaymentMethodManagement;
